import React from "react";
import { useState } from "react";
import rain from "./BackgroundImage/rain.jpg";
import thunder from "./BackgroundImage/thunder.jpg";
import cloudy from "./BackgroundImage/mist.png";
import clear from "./BackgroundImage/clear.webp";
import snow from "./BackgroundImage/snow.png";
import Forcaste from "./Forcaste";
import "./Card.css";
import { useEffect } from "react";

function Card(urlLink) {
  // console.log(urlLink);
  const [background, setBackground] = useState({
    image: "",
    color: "black",
  });
  const [temp, setTemp] = useState("");
  const [fontWeight, setFontWeight] = useState({
    C: "500",
    F: "300",
  });

  const [element, setElement] = useState({
    name: "",
    icon: "",
    country: "",
    day: "",
    feelsLike_C: "",
    humidity: "",
    pressure: "",
    visibiliy: "",
    windSpeed: "",
    windDegree: "",
    windDirection: "",
    condition: "",
    Date: "",
    month: "",
    year: "",
    hr: "",
    min: "",
    time: "",
    temp_c: "",
    temp_f: "",
    code: 0,
  });

  const getDayCus = (num) => {
    if (num === 1) {
      return "Mon";
    } else if (num === 2) {
      return "Tue";
    } else if (num === 3) {
      return "Wed";
    } else if (num === 4) {
      return "Thu";
    } else if (num === 5) {
      return "Fri";
    } else if (num === 6) {
      return "Sat";
    } else {
      return "Sun";
    }
  };

  // useEffect(() => {
  //   headlineUpdate();
  //   console.log("called");
  // });

  function selectBackground() {
    if (
      element.code == 1063 ||
      element.code == 1150 ||
      element.code == 1153 ||
      element.code == 1180 ||
      element.code == 1183 ||
      element.code == 1186 ||
      element.code == 1189 ||
      element.code == 1192 ||
      element.code == 1195 ||
      element.code == 1198 ||
      element.code == 1201 ||
      element.code == 1204 ||
      element.code == 1207 ||
      element.code == 1240 ||
      element.code == 1243 ||
      element.code == 1246 ||
      element.code == 1249 ||
      element.code == 1252 ||
      element.code == 1255 ||
      element.code == 1258 ||
      element.code == 1261 ||
      element.code == 1264 ||
      element.code == 1273
    ) {
      setBackground({
        image: rain,
      });
    }
    if (
      element.code === 1084 ||
      element.code === 1213 ||
      element.code === 1276 ||
      element.code === 1279 ||
      element.code === 1282
    ) {
      setBackground({
        image: thunder,
      });
    }
    if (
      element.code === 1003 ||
      element.code === 1006 ||
      element.code === 1009
    ) {
      setBackground({
        image: cloudy,
      });
    }
    if (element.code === 1000) {
      setBackground({
        image: clear,
      });
    }
    if (
      element.code === 1066 ||
      element.code === 1069 ||
      element.code === 1072 ||
      element.code === 1114 ||
      element.code === 1117 ||
      element.code === 1171 ||
      element.code === 1216 ||
      element.code === 1219 ||
      element.code === 1222 ||
      element.code === 1225 ||
      element.code === 1237
    ) {
      selectBackground({
        image: snow,
      });
    }
  }

  async function headlineUpdate() {
    let url = `https://api.weatherapi.com/v1/current.json?key=aca3adb7d6554c3f80323651222706&q=${Object.values(
      urlLink
    )}&aqi=no`;

    let data = await fetch(url);
    let p_data = await data.json();
    let p_date = new Date(p_data.current.last_updated);
    setElement({
      name: p_data.location.name,
      icon: p_data.current.condition.icon,
      country: p_data.location.country,
      time: p_data.location.last_updated,
      feelsLike_C: p_data.current.feelslike_c,
      humidity: p_data.current.humidity,
      pressure: p_data.current.pressure_mb,
      visibiliy: p_data.current.vis_km,
      windSpeed: p_data.current.wind_kph,
      windDegree: p_data.current.wind_degree,
      windDirection: p_data.current.wind_dir,
      condition: p_data.current.condition.text,
      day: p_date.getDay(),
      Date: p_date.getDate(),
      month: p_date.getMonth(),
      year: p_date.getFullYear(),
      hr: p_date.getHours(),
      min: p_date.getMinutes(),
      temp_c: p_data.current.temp_c,
      temp_f: p_data.current.temp_f,
      code: p_data.current.condition.code,
    });
    selectBackground();
  }

  function formateMin(min) {
    if (min === 0) {
      return "00";
    }
    if (min < 0) {
      return "0" + min;
    } else {
      return min;
    }
  }

  function toggleScaleToC() {
    setTemp(element.temp_c);
    setFontWeight({
      C: "500",
      F: "300",
    });
  }

  function toggleScaleToF() {
    setTemp(element.temp_f);
    setFontWeight({
      F: "500",
      C: "300",
    });
  }

  useEffect(() => {
    setTimeout(() => {
      headlineUpdate();
    }, 1000);
  });

  return (
    <>
      <div className="container">
        <div
          className="card-bg"
          style={{
            backgroundImage: `url(${background.image})`,
            color: `${background.color}`,
          }}
        >
          <div className="location">
            <p>{element.name}</p>
            <p>{element.country}</p>
          </div>

          <div className="temperature">
            <div
              className="icon"
              style={{ backgroundImage: `url(${element.icon})` }}
            ></div>
            <div className="tempMeter">
              <p>{temp ? temp : element.temp_c}</p>
              <div className="scale">
                <a className="link" onClick={toggleScaleToC}>
                  <p
                    style={{
                      fontWeight: `${fontWeight.C}`,
                    }}
                  >
                    &#176; C
                  </p>{" "}
                </a>
                <a className="link" onClick={toggleScaleToF}>
                  <p
                    style={{
                      fontWeight: `${fontWeight.F}`,
                    }}
                  >
                    &#176; F
                  </p>
                </a>
              </div>
            </div>
          </div>
          <div className="condition">
            <span className="text-custom">
              <p className="text-muted text-sm" style={{ fontSize: "10px" }}>
                Condition:
              </p>

              {`${element.condition}`}
            </span>

            <span className="text-custom">
              <p className="text-muted" style={{ fontSize: "10px" }}>
                Day:
              </p>
              {`${getDayCus(element.day)}`}
            </span>
            <span className="text-custom">
              <p className="text-muted" style={{ fontSize: "10px" }}>
                last Updated:{" "}
              </p>
              {`${element.Date}-${element.month}-${element.year}`}
            </span>
            <span className="text-custom">
              <p className="text-muted" style={{ fontSize: "10px" }}>
                last Updated on time:{" "}
              </p>
              {`${element.hr < 10 ? "0" + element.hr : element.hr}:${formateMin(
                element.min
              )}`}
            </span>
          </div>
          <div className="additonalInfo">
            <div className="info1">
              <p className="info-heading ">Feels Like</p>
              <p className="info-reading">{element.feelsLike_C} &#176; C</p>
            </div>
            <div className="info2">
              <p className="info-heading ">Humidity</p>
              <p className="info-reading">{element.humidity} &#176; C</p>
            </div>
            <div className="info3">
              <p className="info-heading ">Pressure</p>
              <p className="info-reading">{element.pressure} mb</p>
            </div>
            <div className="info4">
              <p className="info-heading ">Visibility</p>
              <p className="info-reading">{element.visibiliy} %</p>
            </div>
            <div className="info5">
              <p className="info-heading ">Wind Speed</p>
              <p className="info-reading">{element.windSpeed} KPH</p>
            </div>
            <div className="info6">
              <p className="info-heading ">Wind Direction</p>
              <p className="info-reading">
                {element.windDegree}&#176; {element.windDirection}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;
